import { render } from "./EventDetailApplication.vue?vue&type=template&id=66456894&scoped=true"
import script from "./EventDetailApplication.vue?vue&type=script&lang=js"
export * from "./EventDetailApplication.vue?vue&type=script&lang=js"

import "./EventDetailApplication.vue?vue&type=style&index=0&id=66456894&lang=scss&scoped=true"

import exportComponent from "/var/www/html/app_player/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66456894"]])

export default __exports__